import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  FormGroup,
  Input,
  Label,
  Offcanvas,
  OffcanvasBody,
  OffcanvasHeader,
  Row,
} from "../../components/Common/AppOverlay";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {
  ColumnDirective,
  ColumnsDirective,
  GridComponent,
  Inject,
  Page,
  Toolbar,
  ButtonComponent,
} from "../../components/Common/LegacyGridAdapter";

const ReportMenu = () => {
  let gridInstance;
  const history = useNavigate();

  useEffect(() => {}, []);

  const toolbarOptions = [
    { text: "Excel Export", prefixIcon: "e-excelexport", id: "excel" },
    { text: "Pdf Export", prefixIcon: "e-pdfexport ", id: "pdf" },
    { text: "Csv Export", prefixIcon: "e-csvexport ", id: "csv" },
  ];

  function toolbarClick(args) {
    console.log(args.item.text);
    switch (args.item.text) {
      case "PDF Export":
        gridInstance.pdfExport();
        break;
      case "Excel Export":
        gridInstance.excelExport();
        break;
      case "CSV Export":
        gridInstance.csvExport();
        break;
    }
  }

  return (
    <div className="page-content piers-page">
      <Breadcrumbs
        title="HR Management"
        breadcrumbItem="Report Menu"
        enableAction={false}
      ></Breadcrumbs>
      <Col xl={12}>
        <Row style={{ padding: "5px" }}>
          <Col xl={6}>
            <h4 className="card-title">Document Access Report</h4>
            <p className="card-title-desc">
              Report on who has accessed the documents.
            </p>
          </Col>
          <Col xl={3}>
            <div className="d-flex flex-wrap gap-2">
              <button
                type="button"
                className="btn btn-outline-primary waves-effect waves-light"
                onClick={() => {
                  history.push("/piers/reports");
                }}
              >
                Goto Report
              </button>
            </div>
          </Col>
        </Row>
        <Row>
          <hr />
        </Row>
        <Row style={{ padding: "5px" }}>
          <Col xl={6}>
            <h4 className="card-title">Document Category vs Report</h4>
            <p className="card-title-desc">
              Report on documents based on category and subcategory
            </p>
          </Col>
          <Col xl={3}>
            <div className="d-flex flex-wrap gap-2">
              <button
                type="button"
                className="btn btn-outline-primary waves-effect waves-light"
                onClick={() => {
                  history.push("/piers/reports");
                }}
              >
                Goto Report
              </button>
            </div>
          </Col>
        </Row>
        <Row>
          <hr />
        </Row>
        <Row style={{ padding: "5px" }}>
          <Col xl={6}>
            <h4 className="card-title">Search Usage Report</h4>
            <p className="card-title-desc">
              Report on how users are using the search
            </p>
          </Col>
          <Col xl={3}>
            <div className="d-flex flex-wrap gap-2">
              <button
                type="button"
                className="btn btn-outline-primary waves-effect waves-light"
                onClick={() => {
                  history.push("/piers/reports");
                }}
              >
                Goto Report
              </button>
            </div>
          </Col>
        </Row>
        <Row>
          <hr />
        </Row>
        <Row style={{ padding: "5px" }}>
          <Col xl={6}>
            <h4 className="card-title">Document Index Details Report</h4>
            <p className="card-title-desc">Document Index Details Report</p>
          </Col>
          <Col xl={3}>
            <div className="d-flex flex-wrap gap-2">
              <button
                type="button"
                className="btn btn-outline-primary waves-effect waves-light"
                onClick={() => {
                  history.push("/piers/reports");
                }}
              >
                Goto Report
              </button>
            </div>
          </Col>
        </Row>
        <Row>
          <hr />
        </Row>
        <Row style={{ padding: "5px" }}>
          <Col xl={6}>
            <h4 className="card-title">Document Summary Report</h4>
            <p className="card-title-desc">
              Report to view the complete document details
            </p>
          </Col>
          <Col xl={3}>
            <div className="d-flex flex-wrap gap-2">
              <button
                type="button"
                className="btn btn-outline-primary waves-effect waves-light"
                onClick={() => {
                  history.push("/piers/reports");
                }}
              >
                Goto Report
              </button>
            </div>
          </Col>
        </Row>
        <Row>
          <hr />
        </Row>
        <Row style={{ padding: "5px" }}>
          <Col xl={6}>
            <h4 className="card-title">Files Detail Report</h4>
            <p className="card-title-desc">
              Report to view the complete file details
            </p>
          </Col>
          <Col xl={3}>
            <div className="d-flex flex-wrap gap-2">
              <button
                type="button"
                className="btn btn-outline-primary waves-effect waves-light"
                onClick={() => {
                  history.push("/piers/reports");
                }}
              >
                Goto Report
              </button>
            </div>
          </Col>
        </Row>
        <Row>
          <hr />
        </Row>
      </Col>
    </div>
  );
};

export default ReportMenu;
